import { Injectable, inject } from '@angular/core';
import { PartyMiscModel } from '../../cmg-1003/models/party-misc.model';
import { Query } from '@datorama/akita';
import { PartyMiscStore } from './party-misc.store';

@Injectable({ providedIn: 'root' })
export class PartyMiscQuery extends Query<PartyMiscModel> {
  protected store: PartyMiscStore;

  constructor() {
    const store = inject(PartyMiscStore);

    super(store);

    this.store = store;
  }
}
